export default {
  title: 'Plugins'
}
